import { useEffect, useMemo, useState } from 'react';
import { companiesAPI } from '../lib/api';
import { fetchAllPages } from '../lib/fetchAllPages';
import { nomLisible } from '../lib/libelles';

/**
 * Les transporteurs (sociétés partenaires) pour un menu de recherche : toutes
 * les pages, pas seulement la première. Un échec laisse le menu vide, l'écran
 * reste utilisable.
 */
export function useTransporteursLots() {
  const [societes, setSocietes] = useState([]);

  useEffect(() => {
    let actif = true;
    fetchAllPages((page) => companiesAPI.getAllPaged(page))
      .then((resultat) => {
        if (actif) setSocietes(resultat.items || []);
      })
      .catch(() => {
        if (actif) setSocietes([]);
      });
    return () => {
      actif = false;
    };
  }, []);

  const options = useMemo(
    () =>
      societes
        .filter((societe) => societe?.id)
        .map((societe) => ({
          value: societe.id,
          label: nomLisible(societe.name, 'Société sans nom'),
          keywords: [societe.city, societe.phone],
        })),
    [societes],
  );

  return { societes, options };
}

export default useTransporteursLots;
